import { render, staticRenderFns } from "./SalaryStatistics.vue?vue&type=template&id=50c1b2c3"
import script from "./SalaryStatistics.vue?vue&type=script&lang=js"
export * from "./SalaryStatistics.vue?vue&type=script&lang=js"
import style0 from "./SalaryStatistics.vue?vue&type=style&index=0&id=50c1b2c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports